import z from 'zod';

export const SavedJobListItemVMSchema = z.object({
	id: z.string(),

	companyName: z.string(),
	coverImage:  z.string().default(''),
	detailUrl:   z.string().url().nullable(),
	entryUrl:    z.string().url().nullable(),
	expiredAt:   z.string(),
	location:    z.string(),
	postedAt:    z.string(),
	status:      z.enum([ 'RECRUITING', 'CLOSING_SOON', 'CLOSED' ]),
	title:       z.string(),

	salary: z.object({
		max: z.number().nullable(),
		min: z.number().nullable(),
	}),
});
export type SavedJobListItemVM = z.infer<typeof SavedJobListItemVMSchema>;
